<template>
    <div>
        <h2 class="text-primary"><strong>Consultar seguimiento</strong></h2>
        <vx-input-group>
            <vs-row>
                <vs-col vs-w="8">
                    <vs-input class="full-width mr-6 pr-10" type="text" placeholder="Ej.: 112-065509-20210202" v-model="folio"/>
                </vs-col>
                <vs-col vs-w="4">
                    <vs-button class="full-width mb-6"  v-on:click="getFollow">Seguimiento</vs-button>
                </vs-col>
            </vs-row>
        </vx-input-group>
        <div class="border-bottom">
            <div id="jsoneditorSeguimiento" style="width: 100%; height: 300px;"></div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'seguimiento',
    props: {
        folioProp: String,
    },
    data() {
        return {
            folio: "",
            containerSeguimiento: null,
            editorSeguimiento: null,
            responseSeguimiento: null,
        };
    },
    created() {
        this.addLibraries();
    },
    mounted() {
        this.folio = this.folioProp;
        this.containerSeguimiento = document.getElementById("jsoneditorSeguimiento");
    },
    methods: {
        addLibraries() {
            let externalScript = document.createElement('script');
            externalScript.setAttribute('src',
                'https://cdnjs.cloudflare.com/ajax/libs/jsoneditor/9.5.6/jsoneditor.min.js');
            // externalScript.setAttribute('integrity', 'sha512-E55fZmvWxbgtaLuphoqjaJ5rZX36f0yfq//rH6KMz8rIPd+Q5x7tU4xdRUxG1x+uTQ1zcXkvP1nVApFSJs5X2w==');
            document.head.appendChild(externalScript);
            let externalStyle = document.createElement('link');
            externalStyle.setAttribute('href',
                'https://cdnjs.cloudflare.com/ajax/libs/jsoneditor/9.5.6/jsoneditor.min.css');
            externalStyle.setAttribute('rel', 'stylesheet');
            // externalStyle.setAttribute('integrity', 'sha512-KUAYxdtovjDFrnJvy5/8xWbJUUf41CIwieVmjF2dFzqLZhrdZj6urqX/0/06J+cqs5BlaZQwwwEnaShUy7LHrw==');
            document.head.appendChild(externalStyle);
        },
        async getFollow() {
            const urlToSend = `/api/sitiapi/seguimiento/${this.folio}`;
            await this.requestGet(urlToSend, (jsonReponse) => this.startEditorSeguimiento(jsonReponse));
        },
        startEditorSeguimiento(jsonEditorSeguimiento) {
            if (this.editorSeguimiento === null) {
                this.editorSeguimiento = new JSONEditor(this.containerSeguimiento, this.options);
            }
            this.editorSeguimiento.set(jsonEditorSeguimiento);
        },
        async requestGet(url, callback) {
            await axios.get(url)
                .then(response => (this.responseSeguimiento = response.data));
            callback(this.responseSeguimiento);
        },
    },
}
</script>

<style scoped>
.full-width {
    width:100%;
}
</style>